"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2273],{

/***/ 22273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_WhoWeAre; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./models/enums/routes.ts
var routes = __webpack_require__(20365);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
// EXTERNAL MODULE: ./styledComponents/LinkButtonWithGradientHover/index.ts + 2 modules
var LinkButtonWithGradientHover = __webpack_require__(68413);
;// CONCATENATED MODULE: ./components/sections/WhoWeAre/whoWeAre.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 5rem;\n    padding-bottom: 4rem;\n    row-gap: 2rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 2rem;\n    max-width: 100%;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 2rem;\n    max-width: 28rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 0rem;\n    max-width: 38rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 40rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0rem 0rem 1.375rem 0rem;\n    max-width: 50rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.5rem;\n    line-height: 2rem;\n    font-weight: 400;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0;\n    flex: 1;\n    justify-content: flex-start;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0.75rem 0;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}






const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "eks9sqn0"
})(mixins/* defaultContainerSize */.sX, ";display:flex;flex-wrap:wrap;z-index:0;position:relative;padding-top:2rem;padding-bottom:3rem;row-gap:1.5rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject())));
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "eks9sqn1"
})(Typography/* Header1 */.R6, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:0rem 0rem 1rem 0rem;", mixins.mq.mSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "eks9sqn2"
})(Typography/* ParagraphS */.fw, ";margin:0;color:", theme/* THEME.colors.core_black */.C.colors.core_black, ";flex:3 1;display:inline;", mixins.mq.mobileMax((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), " ", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");
const DescriptionWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eks9sqn3"
})("float:left;");
const ContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eks9sqn4"
})("display:flex;flex-direction:column;");
const LearnMoreWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eks9sqn5"
})("display:flex;align-items:center;flex:0 0 100%;padding-top:0rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())));
const StyledLinkButtonWithGradientHover = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(LinkButtonWithGradientHover/* default */.Z, {
    target: "eks9sqn6"
})("transition:background-color 3000ms ease-in-out;padding:0.5rem 0rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";&:hover{background:linear-gradient(\n      67.33deg,", theme/* THEME.colors.primary */.C.colors.primary, " -19.99%,", theme/* THEME.colors.accent */.C.colors.accent, " 98.54%\n    );}svg{margin-left:16px;path{transition:stroke 200ms ease-in-out;stroke:", theme/* THEME.colors.core_white */.C.colors.core_white, ";}}");

;// CONCATENATED MODULE: ./components/sections/WhoWeAre/WhoWeAre.tsx




const WhoWeAre = (param)=>{
    let { title , description , descriptionSecondary , buttonLabel  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        children: prismic_reactjs.RichText.asText(title)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DescriptionWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                                children: prismic_reactjs.RichText.asText(description)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                                children: prismic_reactjs.RichText.asText(descriptionSecondary)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LearnMoreWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledLinkButtonWithGradientHover, {
                    href: routes/* Routes.AboutUs */.Z.AboutUs,
                    children: [
                        prismic_reactjs.RichText.asText(buttonLabel),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                            width: "21",
                            height: "12",
                            viewBox: "0 0 21 12",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M1 6H19.5M19.5 6L14.5 1M19.5 6L14.5 11",
                                strokeWidth: "2",
                                strokeLinecap: "round"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/WhoWeAre/index.ts

/* harmony default export */ var sections_WhoWeAre = (WhoWeAre);


/***/ })

}]);